import { fetchList, getAmountAvailable } from "@/api/dashboard";

const state = {
  dashboard: {
    today: 0,
    total_week: 0,
    total_month: 0,
    total: 0,
    total_btc: 0,
    total_ada: 0
  }
};

const mutations = {
  UPDATE_DASHBOARD_DATA(state, payload) {
    state.dashboard = payload;
  }
};

const actions = {
  getDashboardData({ commit }, query) {
    return new Promise((resolve, reject) => {
      fetchList(query)
        .then(response => {
          commit("UPDATE_DASHBOARD_DATA", response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAmountAvailable({ commit }, coin) {
    return new Promise((resolve, reject) => {
      getAmountAvailable(coin)
        .then(response => {
          resolve(response["data"]);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const getters = {
  dashboardData: state => state.dashboard
};

const dashboardModule = {
  state,
  mutations,
  actions,
  getters
};

export default dashboardModule;
